import axios from "@/plugins/axios";
import { formatDateTime } from "@/utils/datehelper";

export const state = () => ({
  quotations: [],
  quotation: {},
  isSubmittedQuotation: false,
  addedQuotation: {},
  isSelected: false,
});

export const mutations = {
  SET_QUATATIONS(state, payload) {
    state.quotations = payload;
  },

  SET_QUATATION(state, payload) {
    state.quotation = payload;
  },

  SET_ADDED_QUOTATION(state, payload) {
    state.addedQuotation = payload;
  },

  SET_ISSUBMITTEDSALE(state, payload) {
    state.isSubmittedQuotation = payload;
  },
  SET_SELECTED(state, payload) {
    state.isSelected = payload;
  },
};

export const actions = {
  async fetchQuotations({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/quotations", payload)
        .then((res) => {
          commit("SET_QUATATIONS", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  async fetchQuatation({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`pos/quotations/${payload.id}`)
        .then((res) => {
          var values = [];
          res.data.data.quotationItem.map((item) => {
            values.push({
              id: item.product.id,
              code: item.product.code,
              name: item.product.name,
              price: item.amount,
              quantity: item.quantity,
              unit: item.unit,
              batch: item.batch,
            });
          });
          if (payload.callback && typeof payload.callback == "function") {
            payload.callback({
              values: values,
              customer: res.data.data.customer,
            });
          }
          commit("SET_SELECTED", true);
          commit("SET_QUATATION", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  async onCreateQuotation({ state, commit, rootGetters }, payload = {}) {
    return new Promise((resolve, reject) => {
      var items = payload.items.map((item) => {
        var itemData = {
          product_id: item.id,
          batch_id: item.batch.id,
          unit_id: item.unit.id,
          quantity: item.quantity,
          // amount: item.batch.isBargained
          //   ? item.price - item.batch.bargained_amount
          //   : item.price,
          amount: item.price,
          discount: item.batch.isBargained ? item.batch.bargained_amount : 0,
        };
        return itemData;
      });

      var data = {
        date: formatDateTime(new Date()),
        customer_id: payload.customer.id,
        shop_id: rootGetters["shops/GetShopId"],
        note: "",
        items: items,
      };

      axios
        .post("pos/quotations", data)
        .then((res) => {
          commit("SET_ADDED_QUOTATION", res.data);
          commit("SET_ISSUBMITTEDSALE", true);

          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
